import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Join from './component/join/Join';
import Chat from './component/chat/Chat';


function App() {

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route exact path='/' element={<Join />}></Route>
          <Route exact path='/chat' element={<Chat />}></Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
